module.exports = __webpack_public_path__ + "img/“ (2) (1).b9d9b2c6.svg";